// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"119":"store","985":"album"}[chunkId] + "-legacy." + {"119":"074e106d","985":"26deef2e"}[chunkId] + ".js";
};